var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{class:{'dark':_vm.skinType},attrs:{"stripe":"","size":"mini","data":_vm.tableData,"height":"100%","row-class-name":function (){
var nu = [], len = arguments.length;
while ( len-- ) nu[ len ] = arguments[ len ];
return _vm.skinType?'dark text-white':''}}},_vm._l((_vm.tableColumn),function(col,index){return _c('el-table-column',{key:index,attrs:{"min-width":"88","fixed":col=='type'?'fixed':false,"prop":col,"label":col=='type'?'类型':col,"align":"center"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }